<button class="validation-navigator" (click)="onClick()">
  <esp-icon class="validation-icon" name="circle-alert"></esp-icon>
  <div>{{invalidCount}} {{"validation.invalid.values"|translate}}</div>
</button>
